// Dependencies
import React, { FunctionComponent, useEffect } from 'react'

// Types
import { ModalProps } from './modal.types'

// Styles
import { Container, OverlayContainer } from './modal.styles'

export const Modal: FunctionComponent<ModalProps> = ({
  isOpened = false,
  content,
  handleOutsideClick
}) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (isOpened) {
        window.document.body.style.overflow = 'hidden'
      } else {
        window.document.body.style.overflow = 'auto'
      }
    }
  }, [isOpened])

  return (
    <Container isOpened={isOpened}>
      <OverlayContainer
        onClick={() => !!handleOutsideClick && handleOutsideClick()}
      />
      {content}
    </Container>
  )
}
